module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Introduction: Three Midwestern Playwrights and the Provincetown Players"
    }
  }, [_c('p', {
    staticClass: "imagech"
  }, [_c('img', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "alt": "Images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chno"
  }, [_c('a', {
    attrs: {
      "id": "int"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/Contents#r_int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "chap_head1b"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#r_int"
    }
  }, [_c('i', [_vm._v("Three Midwestern Playwrights and the Provincetown Players")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_para"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TWO LOVE TRIANGLES ANIMATE")]), _vm._v(" this book, one driven by free love and the other by true love. When Floyd Dell fell in love with his best friend’s wife, Mollie Price Cook, their affair was brief but blissful. When George Cram Cook fell in love with Susan Glaspell and left Mollie and his two children to marry her, their ten-year union endured until his death, continually tested by infidelity and alcoholism.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("These love stories run parallel to the larger story that this book relates, a part of the Provincetown Players’ story that has not yet been told. This larger story focuses on the ways in which three Midwestern playwrights’ involvement in progressive activities in early twentieth-century Davenport, Iowa, helped shape the trajectory and theatre practice of the company. Established in 1915 by twenty-nine charter members (among them Dell, Cook, and Glaspell), the Provincetown Players was one of sixty-three amateur theatres that were formed in the United States during that decade. By 1926, there were five thousand."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/Notes#intfn1",
      "id": "intfn1a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("Today, the Provincetown Players is best known for discovering Nobel laureate Eugene O’Neill and producing sixteen of his plays."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/Notes#intfn2",
      "id": "intfn2a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" But by 1922, when the group produced its last play, it had made several equally significant contributions to American theatre. In just eight years, the company had developed an alternative to the commercial Broadway stage, establishing a laboratory for new playwrights to experiment and "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("introducing new forms of theatre and new staging techniques to the American public."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/Notes#intfn3",
      "id": "intfn3a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Dorothy Chansky points out that beyond these innovations, little theatres like the Provincetown Players accomplished the essential mission of building an educated and appreciative audience for the New Drama in America. Dell, Cook, Glaspell, and, of course, O’Neill, as well as the other Provincetown playwrights, played a key role in this effort.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("This book argues that the Provincetown Players would not have become the theatre company that it did without Dell, Cook, and Glaspell’s early involvement in socially progressive movements in Davenport, Iowa, during the first decade of the twentieth century. In Davenport, Dell became a feminist and a leader in the city’s Socialist Party. In Davenport, Cook ran for public office as a Socialist and, along with Glaspell, led a movement for free speech and religious freedom. In Davenport, Cook and Dell founded the Monist Society, a group of free thinkers that included Glaspell. This activism shaped not only their own plays but also the aesthetic and theatre practice of the company itself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("When they came together in Davenport in 1903, Glaspell was a former journalist and promising short-story writer, Cook was an author and former college English professor, and Dell was a high school junior who would soon be publishing poems in national magazines. Twelve years later they would found the Provincetown Players and produce their plays there, plays that were shaped in large part by their authors’ early radicalism. These plays would spoof the craze for Freudian psychology and modern art, protest against World War I, explore changing gender dynamics, and enact the importance of free speech in a democracy. A middle-aged Cook would die in Greece in 1924, but Dell and Thomas Mitchell of "), _c('i', [_vm._v("Gone with the Wind")]), _vm._v(" fame would collaborate on a Broadway hit in 1928, and Glaspell would win the Pulitzer Prize for drama in 1931.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_para"
  }, [_vm._v("The fuse of this transformative stick of dynamite was lit when Dell, Cook, and Glaspell discovered something called the New.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-588f6752","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Introduction.vue
// module id = 78
// module chunks = 0